<ng-container *transloco="let t; read: 'products'">
  <div class="componentContainer">
    
    <section class="xs12col componentHeader">
        <h1>{{t('title')}}</h1>
    </section>

    <section class="oneCol">
      <div class="xs12col">
          <div class="boxContainer">
              <div class="box">
                <app-product-grid 
                  [showOrderColumn]="false"
                  [isAdminView]="true"
                  [currentCompany]="currentCompany$ | async">
                </app-product-grid>
              </div>
          </div>
      </div>
    </section>
  </div>
</ng-container>